/*
 *
 * AlertService constants
 *
 */

export const ALERT_ADD = 'app/AlertService/ALERT_ADD';
export const ALERT_DISMISS = 'app/AlertService/ALERT_DISMISS';
